import { render, staticRenderFns } from "./PrescriptionDialog.vue?vue&type=template&id=7b323374&scoped=true"
import script from "./PrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./PrescriptionDialog.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionDialog.vue?vue&type=style&index=0&id=7b323374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b323374",
  null
  
)

export default component.exports